import { PowerPerformanceForms } from '../../../../types/mutual-fund-detail.types'

export function mapRatingToPowerForm(statusRating: string | undefined): `${PowerPerformanceForms}` | null {
  const normalizedRating = (statusRating ?? '').trim().toUpperCase().replace(/\s+/g, '_')
  const validPowerForms = new Set<string>(Object.values(PowerPerformanceForms))
  if (validPowerForms.has(normalizedRating)) {
    return normalizedRating as `${PowerPerformanceForms}`
  }
  return null
}
